import { Box, styled } from '@mui/material';
import { MOBILE_BREAKPOINT } from 'src/config-global';

export const AppGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  width: '100vw',
  gridTemplateAreas: '"header" "content" "mobileBar"',
  gridTemplateColumns: '1fr',
  gridTemplateRows: '48px 1fr 48px',
  // ...(hasNotification && {
  //   gridTemplateAreas: '"notification" "header" "content" "mobileBar"',
  //   gridTemplateRows: '36px 48px 1fr 48px',
  // }),
  '&.isAppCollaborate': {
    gridTemplateAreas: '"content"',
    gridTemplateRows: '1fr',
  },
  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    gridTemplateAreas: '"header" "content"',
    gridTemplateRows: '48px 1fr',
    '&.hasNotification': {
      gridTemplateAreas: '"notification" "header" "content"',
      gridTemplateRows: '36px 48px 1fr',
    },
  },
}));
